import { render } from "./IndexHeroParticle.vue?vue&type=template&id=abb6aeca"
import script from "./IndexHeroParticle.vue?vue&type=script&lang=js"
export * from "./IndexHeroParticle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__